import React, { Component } from 'react';
import { Input } from 'antd';
import { withApollo } from '@apollo/react-hoc';
import ProductLayout from '$components/layout/ProductLayout';
import Seo from '$components/Seo';

import styles from './styles.scss';

class Rewards extends Component {
  handleCopyCode() {
    // eslint-disable-line class-methods-use-this
    const copyTextarea = document.querySelector('[data-aaa=referralCode]');
    copyTextarea.focus();
    copyTextarea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        alert('Copied'); // eslint-disable-line no-alert
      } else {
        alert(
          "We couldn't copy automatically for some reason, but you can still manually copy/paste"
        ); // eslint-disable-line no-alert
      }
    } catch (err) {
      alert(
        "We couldn't copy automatically for some reason, but you can still manually copy/paste"
      ); // eslint-disable-line no-alert
    }
  }

  render() {
    const { currentUser, location, match } = this.props;
    const { referralCode } = currentUser;

    return (
      <>
        <Seo title="Refer and earn" canonical={null} description={null} />
        <ProductLayout currentUser={currentUser} location={location} match={match}>
          {() => (
            <div className={styles.layout}>
              <div className={styles.well}>
                <h1 className={styles.header}>Refer and earn</h1>
                <div className={styles.description}>
                  <p>
                    Enjoying Achievable? We hope you&apos;ll recommend us to a friend or
                    colleague!
                  </p>
                  <p>
                    When they sign up and upgrade using your referral code, everybody
                    wins.
                  </p>
                  <ul>
                    <li>They&apos;ll get $10 off the price</li>
                    <li>You&apos;ll get a $10 Amazon gift card</li>
                  </ul>
                  <Input.Search
                    data-aaa="referralCode"
                    className={styles.codeField}
                    placeholder="input search text"
                    onSearch={this.handleCopyCode}
                    value={`https://achievable.me/?ref=R-${referralCode}`}
                    enterButton={<i className="fad fa-copy" />}
                  />
                  <h2 className={styles.subheader}>Partner program</h2>
                  <div>
                    <p>
                      The link above is meant for easily passing along to your colleagues
                      and friends. If you want to promote us on a larger scale or are
                      interested in getting stats on traffic you send our way, we run a
                      very generous partner marketing program. We keep it low-key so
                      anyone can join.
                    </p>
                    <p>Consider joining our partner program if:</p>
                    <ul>
                      <li>
                        You&apos;re at a larger company and have a company message board
                        or wiki
                      </li>
                      <li>
                        You&apos;re studying at a university and a group will use
                        Achievable
                      </li>
                      <li>You run an online community with a lot of traffic</li>
                      <li>
                        You&apos;re simply interested in making money while promoting a
                        great product!
                      </li>
                    </ul>
                    <p>
                      <a
                        href="mailto:hello@achievable.me"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Tell us
                      </a>{' '}
                      a bit about your audience and we&apos;ll take it from there.
                    </p>
                  </div>
                  <h2 className={styles.subheader}>The fine print</h2>
                  <div>
                    We&apos;re fair and honest folks and we like to give credit where
                    credit is due, but we have to include this section to limit abuse:
                    <ul>
                      <li>You can&apos;t refer yourself</li>
                      <li>We might change this program at any time</li>
                      <li>
                        We reserve the right to deny any referral we suspect is fraudulent
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </ProductLayout>
      </>
    );
  }
}

export default withApollo(Rewards);
